(function() {
    'use strict';

    angular
        .module('quantixApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('aifbenchmark', {
            parent: 'app',
            url: '/aifbenchmark',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/aifbenchmark/aifbenchmark.html',
                    controller: 'AifbenchmarkController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService', function (GenericService, ErrorHandlerService) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (!result['AIF BENCHMARKING']) {
                            ErrorHandlerService.forbiddenError('AIF Benchmarking');
                            return false;
                        } else {
                            return true;
                        }
                    });
                }],
            }
            
        });
    }
})();
